<template>
    <div class="palette-handle">
        <div class="palette-handle__arrows"></div>
    </div>
</template>

<script>
export default {
    name: 'palette-handle',
}
</script>

<style lang="scss" scoped>
    $body-bg: #373636;
    $handle-color: lighten($body-bg, 8%);
    $handle-hover-color: #c0c0c0;

    .palette-handle {
		position: absolute;
		padding: 1.5rem;
        cursor: move;
        cursor: grab;

        &__arrows {
            display: flex;
            flex-flow: column nowrap;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate( -50%, -50% );

			&:before,
			&:after {
				display: block;
                width: 0;
                height: 0;
				border-right: 6px solid transparent;
				border-left: 6px solid transparent;
				background-color: transparent;
				transition: border-color 0.3s ease;
				content: '';
			}
			&:before {
				margin-bottom: 1px;
				border-bottom: 10px solid $handle-color;
			}
			&:after {
				margin-top: 1px;
				border-top: 10px solid $handle-color;
			}
        }

        &:hover,
        .smooth-dnd-ghost & {
            .palette-handle__arrows {
                &:before {
					border-bottom-color: $handle-hover-color;
				}
				&:after {
					border-top-color: $handle-hover-color;
				}
            }
        }
    }
</style>